import { useContext, useEffect } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import { SmartContext } from '../../../library/Core/SmartContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import OutreachDashboardLayout from './OutreachDashboardLayout';
import DebugBarControl from '../../../library/SimpleControls/DebugBarControl';

const OutreachDashboard = () => {
    const navigate = useNavigate();
    const { globalState } = useContext(GlobalContext);
    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: { ROUTER_NAVIGATE: navigate },
    } as any);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as any;

    useEffect(() => {
        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig,
                data,
                domain: new Map([...globalState.domain]),
                internal,
                routeInfo,
            },
        });
    }, []);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            {!state?.flags?.isDataLoading && <OutreachDashboardLayout />}
            <DebugBarControl />
        </SmartContext.Provider>
    );
};

export default OutreachDashboard;
